<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1>{{$t("message.reminder.title")}}</h1>
      </v-col>
    </v-row>

    <!-- エラー -->
    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12" md="8">
        <mp-error :errors="view.errors" message-key="message.reminder.error." />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <div class="text-left">
        <p>{{$t("message.reminder.desc.text1")}}</p>
        <p>{{$t("message.reminder.desc.text2")}}</p>
        </div>
      </v-col>
    </v-row>

    <!-- メールアドレス -->
    <v-row justify="center">
      <v-col cols="12" md="2">
        <mp-label no-color>{{$t("message.reminder.label.mailAddress")}}</mp-label>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="form.mailAddress"
          v-bind:placeholder="$t('message.reminder.ph.mailAddress')"
          id="mailAddress"
          hide-details
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- パスワード再発行ボタン -->
    <v-row justify="center">
      <v-col
        class="text-center"
        cols="8"
        md="3"
      >
          <mp-button
            wide
            @click="goReminder"
          >{{$t("message.reminder.button.change")}}</mp-button>
        <mp-dialog reminder :show="dialog.reminderComplete" @clickOk="goAuthLogin" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <div class="text-left">
        <p>{{$t("message.reminder.desc2.text1")}}</p>
        <p>{{$t("message.reminder.desc2.text2")}}</p>
        <p>{{$t("message.reminder.desc2.text3_1")}}
        {{$t("message.reminder.desc2.text3_2")}}
        {{$t("message.reminder.desc2.text3_3")}}</p>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="8"
        md="3"
      >
        <mp-button wide @click="goLogin">{{ $t('message.reminder.button.back') }}</mp-button>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpError from '@/components/item/MpError.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { Reminder } from '@/api'

export default {
  components: {
    MpLabel,
    MpButton,
    MpError,
    MpDialog
  },
  data: () => ({
    view: {
      errors: []
    },
    form: {
      mailAddress: null
    },
    dialog: {
      reminderComplete: false
    }
  }),
  computed: {
  },
  methods: {
    async loadViewData () {
    },
    async goReminder (ev) {
      await Reminder.Reminder(this.form)
        .then(() => {
          this.dialog.reminderComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    goAuthLogin () {
      this.$router.push({ path: '/auth/login' })
    },
    goLogin () {
      this.$router.push({ path: '/login' })
    }
  },
  created: function () {
    this.loadViewData()
  }
}
</script>
